import { connect } from 'react-redux'

import component from 'components/Categories'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({
  categories: state.categories
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/Categories/containers/CategoriesContainer.js